'use client';

import { ContractWrapper } from '@/components/accountSettings/termsAndCondition/TermsAndConditions';
import TermsPreview from './TermsPreview';
import { color, spacing } from '@/theme/tokens';
import { Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import HTMLDownloadWrapper from '@/components/common/HTMLDownloadWrapper';
import { amlNoticeHtml } from './html/aml-notice-content';

export default function AmlNotice() {
    const t = useTranslations('CommonTermsAndConditions');
    const printableAmlNoticeHtml = `<h1>${t('amlNotice.heading')}</h1>${amlNoticeHtml}`;

    return (
        <>
            <ContractWrapper>
                <Typography
                    variant="heading2bold"
                    color={color.gray[80]}
                    style={{ marginBottom: spacing[32] }}
                    component="div"
                >
                    {t('amlNotice.heading')}
                </Typography>
                {/* Compile-time HTML constant from ./html/*.ts — no runtime or user input reaches this sink. */}
                {/* react-doctor-disable-next-line react-doctor/dangerous-html-sink */}
                <TermsPreview dangerouslySetInnerHTML={{ __html: amlNoticeHtml }} />
            </ContractWrapper>

            <HTMLDownloadWrapper
                filename="W8ShippingAmlNotice"
                downloadButtonText={t('amlNotice.downloadButtonText')}
                downloadText={t('downloadText')}
                htmlContent={printableAmlNoticeHtml}
            />
        </>
    );
}
